import { ApiError } from "../api/client.js";
import { apiUrl } from "../runtime.js";

export interface UploadResult {
  mediaUrl: string;
}

/**
 * POST the captured PNG (raw image/png body) to the app's screenshots route.
 * The backend forwards it to the Discord staging webhook and returns the
 * Discord CDN URL, which the caller passes to `openShareMomentDialog`.
 *
 * @param app   the app's route slug, e.g. "dim" → POST /api/dim/screenshots.
 * @param symbol optional caption symbol, sent as the X-Symbol header.
 */
export async function uploadScreenshot(blob: Blob, app: string, symbol?: string): Promise<UploadResult> {
  const token = (window as unknown as { __token?: string }).__token;
  const headers = new Headers({ "Content-Type": "image/png" });
  if (symbol) headers.set("X-Symbol", symbol);
  if (token) headers.set("Authorization", `Bearer ${token}`);

  const res = await fetch(apiUrl(`/api/${app}/screenshots`), { method: "POST", headers, body: blob });

  if (!res.ok) {
    const retryAfter = Number(res.headers.get("retry-after")) || undefined;
    throw new ApiError(res.status, retryAfter);
  }

  return (await res.json()) as UploadResult;
}
